import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';

import * as _4 from 'lodash4';
import { IRegistrationReceiptModel } from '../../interfaces/scheduler_interfaces';
import { RegistrationReceiptModel } from '../models/registration_reciept_model';

export type RegistrationRecieptCommand = (
  receiptData: IRegistrationReceiptModel['receiptData'],
  showReceipt: IRegistrationReceiptModel['showReceipt']
) => ng.IPromise<IQuery[]>;

angular.module('capability-ng-scheduler').factory(
  'registrationRecieptCommand',
  (defineCommandORM: IDefineCommand, ngRegistrationReceiptModel: RegistrationReceiptModel): ICommand =>
    defineCommandORM(
      'registrationRecieptCommand',
      (
        deferred,
        receiptData: IRegistrationReceiptModel['receiptData'] = [],
        showReceipt: IRegistrationReceiptModel['showReceipt'] = false
      ) => {
        ngRegistrationReceiptModel.clear().write({
          receiptData,
          showReceipt
        });
        deferred.resolve();
      }
    )
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_receipt/commands/registration_reciept_command.ts